import { useEffect, useRef } from "react";

export default function ViewportVideo(props) {
  const ref = useRef(null);
  useEffect(() => {
    const video = ref.current;
    let inView = false;
    const update = () => {
      if (inView && !document.hidden) {
        const playback = video.play();
        playback?.catch(() => { /* Native controls remain available when autoplay is blocked. */ });
      } else video.pause();
    };
    const observer = typeof IntersectionObserver === "undefined" ? null : new IntersectionObserver(([entry]) => {
      inView = entry.isIntersecting && entry.intersectionRatio >= .15;
      update();
    }, { threshold: [0, .15] });
    if (observer) observer.observe(video);
    else { inView = true; update(); }
    document.addEventListener("visibilitychange", update);
    return () => {
      observer?.disconnect();
      document.removeEventListener("visibilitychange", update);
      video.pause();
    };
  }, []);
  return <video {...props} ref={ref} controls muted loop playsInline preload="none" />;
}
